import { Suspense } from 'react'
import { useParams } from 'react-router-dom'
import TimelineEditor from '@/components/TimelineEditor/TimelineEditor'
import Loader from '@/components/loader'

export default function TimelinePage() {
  const { timelineId } = useParams()

  return (
    <div className="flex flex-1 flex-col h-full">
      <Suspense fallback={<Loader status="Loading..." />}>
        <TimelineEditor timelineId={timelineId} />
      </Suspense>
    </div>
  )
}
